export default __webpack_public_path__ + "static/media/logo_full.0d223900.svg";